module.exports = __webpack_public_path__ + "img/cupa.662db9bb.jpg";